import { useEffect, useState } from 'react'

/**
 * Общая обёртка для списков: одна и та же логика «грузим — ошибка — готово».
 * `version` — счётчик из App: любая правка увеличивает его, и список
 * перечитывается, без отдельного флага «надо обновить».
 */
export function useList<T>(
  load: () => Promise<T>,
  version: number
): [T | null, string | null, (error: string | null) => void] {
  const [rows, setRows] = useState<T | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    load()
      .then((data) => alive && setRows(data))
      .catch((e: Error) => alive && setError(e.message))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version])

  return [rows, error, setError]
}
